<template lang="pug">
  div
    .tabBar
      .icon(
      v-for="(tab,index) in tabs" :key='tab.id'
        :class="{'active' : path === tab.path}"
        @click="selTab(tab)"
      )
        figure
          div.unread(v-if="index === 1 && (unreadMessage !== 0 || unreadAds !== false)")
          //- i.fa(:class="tab.icon")
          img.tab-img(:src="tab.img_active" v-if="path === tab.path")
          img.tab-img(:src="tab.img" v-else)
          figcaption {{ tab.title }}
</template>

<script>
export default {
  // props: ['tabs'],
  props: {
    tabs: Array,
    unreadMessage: {
      type: Number,
      default: 0
    },
    unreadAds: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    path() {
      return this.$store.state.route.path
    }
  },
  methods: {
    selTab(tab) {
      this.$router.push(tab.path)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.tabBar {
  background-color: #fff;
  border-top: 1px solid @bd_color;
  height: 1.3rem;
  padding: 0rem 0;
  display: flex;
  justify-content: space-around;
  text-align: center;
  color: #98b8d9;
  .icon {
    width: 100%;
  }
  .icon.active {
    color: #2b82d9;
  }
  figure {
    position: relative;
  }
  .tab-img {
    width: 0.54rem;
    height: 0.54rem;
    margin-top: 0.19rem;
  }
  figcaption {
    margin-top: -0.2em;
  }
  .fa {
    font-size: 0.8rem;
  }
  .unread {
    position: absolute;
    top: 5%;
    left: 60%;
    width: 6px;
    height: 6px;
    background-color: #ff0000;
    border-radius: 50%;
  }
}
</style>
